import { Plugins } from '@capacitor/core';
import { Domain } from 'models/domain.model';
import { LoginResult } from 'models/login.model';
const { Storage } = Plugins;

const key = "loginInfo";

export type LoginStorage = {
    domain: Domain,
    loginResult: LoginResult
}

export const setLoginStorage = async (loginInfo: LoginStorage) => {
    return await Storage.set({
        key: 'loginInfo',
        value: JSON.stringify(loginInfo)
    });
}

export const getLoginStorage = async (): Promise<LoginStorage> => {
    const ret = await Storage.get({ key });
    return ret?.value ? JSON.parse(ret.value!) : null;
}

export const removeLoginStorage = async() => {
    return await Storage.remove({key});
}

